import React, { useState } from "react";
import Container from "../../../components/Container/Container";
import Table from "../../../components/Table/Table";
import { API, STATIC, ROUTER } from "../../../constants/env";
import swal from "sweetalert";

const Listfees = () => {
  const [fields, __] = useState([
    { title: "nom", field: "name" },
    { title: "prix (TND)", field: "price" },
    { title: "periode", field: "period" },
  ]);
  const [data, setData] = React.useState([]);
  const fetchData = (currentPage, count, search, setTotalPage, setTotal) => {
    fetch(
      API.fees.feesList +
        `?page=${currentPage}&count=${count}&searchQuery=${search}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
      }
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          return swal("Error", response.message, "error");
        }
        const data = response.data.map((elem) => {
          return {
            ...elem,
            period: STATIC.PERIODE().find((per) => per.value === elem.period)
              .option,
          };
        });
        setData(data);
        setTotalPage(response.totalPage);
        setTotal(response.total);
      })
      .catch((e) => {});
  };

  return (
    <Container
      name="fees"
      actionRoute={ROUTER.FEES.CREATE}
      actionName="Ajouter fees"
    >
      <Table
        pageName="fees"
        name="fees"
        fields={fields}
        data={data}
        editRoute={(id) => ROUTER.FEES.EDIT(id)}
        deleteApiRoute={API.fees.remove}
        deleteMultiple={API.fees.deleteMultiple}
        fetchData={fetchData}
        showSearch={true}
        stopCheckbox={true}
      />
    </Container>
  );
};

export default Listfees;
